"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { Gallery2RoutedPage } from './deskUi/Gallery2RoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function Gallery2SurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={Gallery2RoutedPage} Loading={MsgDeskLoading} />
}
